import React from 'react';
import Card from './DetailsCard'
import Navbar from './Navbar'
import './AboutUs.css'
import Footer from '../Dashboard/Footer'

const team = require('./TeamDetails.json');

const AboutUs = () => {
    
    return(
        <div className="body">
            <div className="header"><Navbar style={{padding:'0',margin:'0'}}/>
            <div style={{height:'65px',display:'block'}}></div>
            </div>
            <div className="content">
              We're a team of Developers who love to code and learn new things. We build and experiment with silly ideas and try to realize them. 
                   
                    
            </div>
            <div className="profiles">
                <h1>Our Team</h1>

            <div className="cards-container container">
                <div className="row">
                    
                    {team.map((member) => {
                        return (
                            <div className="col-lg-4 col-md-6 col-sm-12">
                            <Card key={team.id} {...member}/>
                            </div>
                        );
                    })}
                              
                </div>
            </div>
            </div>
            <footer>
            <Footer style={{padding:'0',margin:'0'}}/>
            </footer>
        </div>
    );
}

export default AboutUs
